export const change = Symbol('change')
export const disableable = Symbol('disableable')
export const dispatch = Symbol('dispatch')
export const reflectable = Symbol('reflectable')
export const reportable = Symbol('reportable')
export const validatable = Symbol('validatable')
